export const menuItemStyleBlue = {
    padding: '14px 10px 14px 20px',
    color: '#0071BB',
    cursor: 'pointer'
}

export const menuItemStyleRed = {
    padding: '14px 10px 14px 20px',
    color: '#9C1712',
    cursor: 'pointer'
}
